// src/components/lessons/renderers/HeaderRenderer.jsx
import React from 'react';

const HeaderRenderer = ({ block, isMobile }) => {
  const HeadingTag = `h${block.level || 3}`;

  const getHeaderStyle = (level) => {
    const baseStyle = {
      fontWeight: '700',
      marginBottom: isMobile ? '0.75rem' : '1rem',
      color: '#000000',
      lineHeight: '1.3',
      position: 'relative',
      paddingLeft: isMobile ? '0.75rem' : '1rem'
    };

    switch (level) {
      case 2:
        return {
          ...baseStyle,
          fontSize: isMobile ? '1.25rem' : '2rem',
          marginTop: isMobile ? '1.25rem' : '2rem',
          paddingBottom: isMobile ? '0.5rem' : '0.75rem',
          borderBottom: '3px solid #000000'
        };
      case 3:
        return {
          ...baseStyle,
          fontSize: isMobile ? '1.0625rem' : '1.5rem',
          marginTop: isMobile ? '1rem' : '1.5rem',
          paddingBottom: isMobile ? '0.375rem' : '0.5rem',
          borderBottom: '2px solid #E5E7EB'
        };
      case 4:
      default:
        return {
          ...baseStyle,
          fontSize: isMobile ? '1rem' : '1.25rem',
          marginTop: isMobile ? '0.75rem' : '1rem',
          opacity: 0.9
        };
    }
  };

  const getAccentStyle = (level) => {
    const baseAccent = {
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      background: '#3A86FF',
      borderRadius: '2px'
    };

    switch (level) {
      case 2:
        return {
          ...baseAccent,
          width: '5px',
          height: '60%'
        };
      case 3:
        return {
          ...baseAccent,
          width: '4px',
          height: '50%'
        };
      case 4:
      default:
        return {
          ...baseAccent,
          width: '3px',
          height: '40%'
        };
    }
  };

  return (
    <HeadingTag style={getHeaderStyle(block.level)}>
      <span style={getAccentStyle(block.level)} />
      {block.text}
    </HeadingTag>
  );
};

export default HeaderRenderer;